enum Sounds {
  Bounce1 = "bounce-1",
  Bounce2 = "bounce-2",
  Bounce3 = "bounce-3",
  Jump = "jump",
  Message = "message",
  Score = "score",
  Timer = "timer",
  Button = "button",
}

export default Sounds;
